import { ApiLegacyBaseService } from 'api/apiLegacyBase.service';
import { AxiosPromise } from 'axios';
import { CreateParams } from 'api/event-info-legacy/types';
import { DResponse } from 'types/legacy/response.types';

class EventInfoLegacyApiService extends ApiLegacyBaseService {
  createConciergeInfo({
    email,
    message,
    firstName,
    lastName,
    phoneNumber,
    companyName,
    quantity,
    occasion,
    products,
  }: CreateParams): AxiosPromise<DResponse> {
    return this.apibase.post<DResponse>(
      '/business-gifting/default.aspx/AddBusinessConceirgeInfo',
      {
        ContactName: `${firstName} ${lastName}`,
        Email: email,
        ShortMessage: message,
        FirstName: firstName,
        LastName: lastName,
        PhoneNumber: phoneNumber,
        CompanyName: companyName,
        Quantity: quantity,
        Occasion: occasion,
        Products: products,
      },
    );
  }
}

export const eventInfoLegacyApiService = new EventInfoLegacyApiService();
